export const stringUtil = {
  prepareDangerousHTML: (text) =>
    text.trim().replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, ""),

  toBase64: (str) => {
    return btoa(String.fromCharCode(...new TextEncoder().encode(str)));
  },

  fromBase64: (base64) => {
    return new TextDecoder().decode(
      Uint8Array.from(atob(base64), (c) => c.charCodeAt(0)),
    );
  },
};
